import { ResponseError } from '@evimo/client/runtime';

type ApiErrorPayload = {
  message?: string | string[];
};

/** Reads Nest validation text from a generated fetch client's ResponseError. */
export async function readOrganizationClientError(
  error: unknown,
): Promise<string | null> {
  if (!(error instanceof ResponseError)) {
    return null;
  }
  const payload = (await error.response
    .json()
    .catch(() => null)) as ApiErrorPayload | null;
  const rawMessage = payload?.message;
  if (typeof rawMessage === 'string' && rawMessage.trim()) {
    return rawMessage.trim();
  }
  if (Array.isArray(rawMessage)) {
    const lines = rawMessage
      .map((line) => String(line).trim())
      .filter((line) => line.length > 0);
    return lines.length > 0 ? lines.join('; ') : null;
  }
  return null;
}
